// MUI Data Grid v7 requires headers and footer background color to be styled via a mixin
// or else the styles will be overridden
// https://mui.com/x/react-data-grid/style/#theme-header-and-pinned-sections

export default theme => ({
	// Headers, and top & bottom fixed rows
	containerBackground: theme.palette.primary.dark,
});
